import {
  always,
  applySpec,
  ifElse,
  last,
  pipe,
  prop,
  propEq,
  split,
  unary,
} from 'ramda';
import { combineEpics, ofType } from 'redux-observable';
import { of } from 'rxjs';
import {
  switchMap,
  map as rxMap,
  catchError,
  withLatestFrom,
} from 'rxjs/operators';
import { format } from 'date-fns/fp';
import { lengthEq } from 'ramda-adjunct';

import { fetchNolDetail } from '../../nol/detail/actions';
import { nolDetailSelector } from '../../nol/selectors';
import {
  updateBankAccountError,
  updateBankAccountSuccess,
  UPDATE_BANK_ACCOUNT,
  UPDATE_BANK_ACCOUNT_SUCCESS,
} from './actions';

export const toApiBankAccount = applySpec({
  accountNumber: pipe(prop('accountNumber'), split('-'), last),
  bankCode: prop('bankCode'),
  prefix: pipe(
    prop('accountNumber'),
    split('-'),
    ifElse(lengthEq(2), prop(0), always(undefined))
  ),
  thirdParty: ifElse(
    propEq('isThirdParty', true),
    pipe(
      prop('thirdParty'),
      applySpec({
        firstName: prop('firstName'),
        lastName: prop('lastName'),
        birthDate: pipe(prop('birthDate'), format('yyyy-MM-dd')),
        citizenShip: prop('citizenShip'),
        street: prop('street'),
        city: prop('city'),
        postalCode: prop('postalCode'),
        country: prop('country'),
      })
    ),
    always(undefined)
  ),
});

const refetchDetailOnSuccessEpic = (action$, state$) =>
  action$.pipe(
    ofType(UPDATE_BANK_ACCOUNT_SUCCESS),
    withLatestFrom(state$),
    rxMap(([, state]) => nolDetailSelector(state)),
    rxMap(unary(pipe(prop('id'), unary(fetchNolDetail))))
  );

const updateBankAccountEpic = (action$, state$, { ajax }) =>
  action$.pipe(
    ofType(UPDATE_BANK_ACCOUNT),
    switchMap(({ payload }) =>
      ajax({
        useAuth: true,
        method: 'PUT',
        url: `/gateway-server/nol/bank-account/${payload.contractId}`,
        body: toApiBankAccount(payload.data),
      }).pipe(
        rxMap(() => updateBankAccountSuccess()),
        catchError((e) => of(updateBankAccountError(e)))
      )
    )
  );

export default combineEpics(refetchDetailOnSuccessEpic, updateBankAccountEpic);
